import {Component, Input, OnInit} from "@angular/core";
import {DialogComponent} from "../../../../../../../ng2-bootstrap-modal/dialog.component";
import {DialogService} from "../../../../../../../ng2-bootstrap-modal/dialog.service";
import {Utils} from "../../../../../../shared/utils/utils";
import {HostingService} from "../../../hosting.service";
import * as fromStore from "../../../../../../store";
import {Store} from "@ngrx/store";
import {first} from "rxjs/operators";
import {DbActiveModal} from "../../../../../../modules/modal/modal-ref";

export interface IConfirmDialogData {
  header: string;
  message: string;
  cdnMessage?: string;
  cancelButtonText: string;
  confirmButtonText: string;
  confirmButtonClass?: string;
  params?: any;
  size?: string;
  domainId: any;
  websiteId: number;
  childWebsiteId: number;
}

@Component({
    selector: 'db-confirm-domain-delete-dialog',
    templateUrl: './confirm-domain-delete-dialog.component.html',
    styleUrls: ['./confirm-domain-delete-dialog.component.scss'],
    standalone: false
})
export class ConfirmDomainDeleteDialogComponent extends DialogComponent<IConfirmDialogData, Boolean> implements OnInit, IConfirmDialogData {

  @Input() header: string;
  @Input() message: string;
  @Input() cdnMessage?: string;
  @Input() cancelButtonText: string;
  @Input() confirmButtonText: string;
  @Input() confirmButtonClass: string = "db-button_danger";
  @Input() params?: any;
  @Input() size?: string;
  @Input() domainId: any;
  @Input() websiteId: number;
  @Input() childWebsiteId: number;

  public changes: any;
  public removeLoading: boolean;

  constructor(
    private _dialogService: DialogService,
    private _store: Store<fromStore.DbStoreState>,
    private _hostingService: HostingService,
    private _activeModal: DbActiveModal
  ) {
    super(
      _dialogService
    );
  }

  ngOnInit() {
    if (this.params) {
      if (this.params.pluginsCount) {
        this.params.pluginsCount = Utils.wordByCount("plugin", this.params.pluginsCount);
      }
      if (this.params.themesCount) {
        this.params.themesCount = Utils.wordByCount("theme", this.params.themesCount);
      }
    }

  }

  public cancel(): void {
    this._activeModal.close(false);
  }

  public removeDomain() {
    this.removeLoading = true;
    this._hostingService.removeDomain(this.websiteId, this.domainId)
      .pipe(
        first(response => !!response, null)
      )
      .subscribe(response => {
        if (!response) {
          return;
        }
        if (response.success) {
          this.result = true;
          this._store.dispatch(new fromStore.LoadDomains({
            websiteId: this.websiteId,
            childWebsiteId: this.childWebsiteId
          }));
          this._store.dispatch(new fromStore.LoadZones());
        }
        this._activeModal.close(this.result);
        this.removeLoading = false;
      });
  }


}
